export default {
    Create: "create",
    Read: "read",
    Update: "update",
    Delete: "delete",
    Valid: "valid",
    Fusion: "fusion",
    Manage: "manage",
    Pay: "pay",
};